module.exports = __webpack_public_path__ + "static/img/aida_logo.ec5b08b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aida_logo.png
// module id = eZhC
// module chunks = 13